module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_DoubleBrkWalll.67ab2c52.jpg";